import { Navigate, Outlet, useLocation } from 'react-router';

import { AuthLoadingScreen } from '@/components/layout/auth-loading';
import { useAuth } from '@/hooks/use-auth';
import { buildRedirectPath } from '@/lib/redirect-path';

export function AuthGuard() {
  const {
    isAuthenticated,
    isLoading,
    onboardingRequest,
    requiresOnboarding,
    user,
  } = useAuth();
  const location = useLocation();
  const redirectTarget = buildRedirectPath(location);

  if (isLoading) {
    return <AuthLoadingScreen />;
  }

  if (requiresOnboarding) {
    return (
      <Navigate
        to={onboardingRequest === null ? '/onboarding' : '/onboarding/pending'}
        replace
        state={{ from: redirectTarget }}
      />
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: redirectTarget }} replace />;
  }

  if (
    user?.is_superadmin !== true
    && (user === null || user.membership_id === null)
    && location.pathname !== '/invitations'
  ) {
    return <Navigate to="/invitations" state={{ from: redirectTarget }} replace />;
  }

  return <Outlet />;
}
